import * as React from "react";

import Icon from "./Icon";
import Button from "./Button";

export default class Modal extends React.Component {
  constructor(props) {
    super(props);

    this.state = { opened: false };

    this.close = this.close.bind(this);
  }

  componentDidMount() {
    this.setState({ opened: true });
  }

  isOpened = () => this.state.opened;

  close() {
    this.setState(
      {
        opened: false
      },
      () => {
        this.props.onClose();
      }
    );
  }

  render() {
    const { children, width } = this.props;
    return this.isOpened() ? (
      <div
        className="modal"
        onClick={(e) => {
          let el = e.target;
          if (el.className === 'modal') {
            this.close()
          }
        }
        }
      >
        <Button classes="close" onClick={this.close}>
          <Icon icon="carpi" />
        </Button>
        <div className="inner" style={{ width: width + '%' }}>{children}</div>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/theme/Modal.js